import { api } from "@/lib/api";

/* 📈 Ad tracking — captures ?src=tiktok_ng style tags from paid ads.
   First-touch: the first src a visitor arrives with is kept and later
   attached to their Deriv account via the presence ping. Storage access is
   guarded (sandboxed webviews can throw on localStorage reads). */
const KEY = "vts_ad_src";
const SENT = "vts_ad_visit_sent";
const VALID = /^[a-z0-9_-]{2,32}$/i;

const safe = (fn, fb = null) => { try { return fn(); } catch { return fb; } };

export const recordAdSrc = (tag) => {
  if (!VALID.test(tag)) return;
  safe(() => { if (!localStorage.getItem(KEY)) localStorage.setItem(KEY, tag); });
  if (!safe(() => sessionStorage.getItem(SENT))) {
    api.post("/adtrack/visit", { src: tag }).catch(() => {});
    safe(() => sessionStorage.setItem(SENT, "1"));
  }
};

export const captureAdSrc = () => {
  const src = safe(() => new URLSearchParams(window.location.search).get("src"));
  if (!src || !VALID.test(src)) return;
  recordAdSrc(src.toLowerCase());
};

export const getAdSrc = () => safe(() => localStorage.getItem(KEY));
